import request from '@/utils/request'


// 查询系统客服列表
export function listConfig(query) {
  return request({
    url: '/customer/config/list',
    method: 'get',
    params: query
  })
}

// 查询系统客服分页
export function pageConfig(query) {
  return request({
    url: '/customer/config/page',
    method: 'get',
    params: query
  })
}

// 查询系统客服详细
export function getConfig(data) {
  return request({
    url: '/customer/config/detail',
    method: 'get',
    params: data
  })
}

// 新增系统客服
export function addConfig(data) {
  return request({
    url: '/customer/config/add',
    method: 'post',
    data: data
  })
}

// 修改系统客服
export function updateConfig(data) {
  return request({
    url: '/customer/config/edit',
    method: 'post',
    data: data
  })
}

// 删除系统客服
export function delConfig(data) {
  return request({
    url: '/customer/config/delete',
    method: 'post',
    data: data
  })
}
